module.exports = __webpack_public_path__ + "img/nose-03.23f0a4ff.svg";